export default {
  description: '¿Aún no has sido redirigido a tu página?',
  cta: 'Haz clic aquí para continuar',
};
